enum Links {
  ELFA = `http://elfa.brassbrasil.com.br:8030/`,
  BIM_360 = `https://docs.b360.autodesk.com`,
  PERSONAL_DEPARTMENT = 'https://departamentopessoal.bdbsystem.com.br',
}

export { Links };
